/**
 * @namespace source.items.siteMedia
 */
import { toItem } from './mappers/item';
import { toError } from './parsers/error';
import { MediaType } from '../../constants/MediaType';
export function initItemsSiteMedia(settings, http) {
  function mapItemList(res, thumbnailSizes) {
    const isSiteOwner = res.data.site_owner;
    res.data = (res.data.files || []).map(function (file) {
      const item = toItem(file, settings, thumbnailSizes, isSiteOwner);
      item.isInSiteMedia = true;
      return item;
    });
    return res;
  }
  const defaultPaging = {
    size: 50,
    cursor: null
  };
  const defaultSort = {
    order: 'date',
    direction: 'desc'
  };
  function list(folderId, options) {
    options = options || {};
    const sort = {
      ...defaultSort,
      ...options.sort
    };
    const paging = {
      ...defaultPaging,
      ...options.paging
    };
    const queryParams = {
      page_size: paging.size,
      cursor: paging.cursor,
      parent_folder_id: folderId,
      media_type: options.mediaType || MediaType.Picture,
      siteMediaToken: settings.siteMediaToken
    };
    queryParams.order = sort.direction === 'desc' ? "-" + sort.order : sort.order;
    return http.get(settings.apiUrl + "/files/getpage/site", queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        size: paging.size,
        cursor: response.data.cursor
      };
      return mapItemList(response, options.thumbnails);
    }).catch(toError);
  }

  /**
   * Remove items from siteMedia
   * @param itemIds Array of item ids
   * @param options
   * @returns [Promise] Array of Promise
   */
  function remove(itemIds, options) {
    options = options || {};
    const data = {
      files: itemIds
    };
    const url = settings.apiUrl + "/files/site/remove?siteMediaToken=" + settings.siteMediaToken;
    const postOptions = {
      headers: options.headers || {}
    };
    return http.post(url, data, null, postOptions).then(function (res) {
      res.data = {
        itemIds
      };
      return res;
    }).catch(toError);
  }

  /**
   * Add items to siteMedia
   * @param itemIds Array of item ids
   * @param options
   * @returns Promise
   */
  function add(itemIds, options) {
    options = options || {};
    const data = {
      files: itemIds
    };
    const url = settings.apiUrl + "/files/site/add?siteMediaToken=" + settings.siteMediaToken;
    const postOptions = {
      headers: options.headers || {}
    };
    return http.post(url, data, null, postOptions).catch(toError);
  }
  return {
    list,
    remove,
    add
  };
}